import axios from "axios";

// const API_BASE_URL = "https://demoapi.softana.com.tr/api"; // HTTPS geri döndü
const API_BASE_URL = "https://api.obatekstil.com.tr/api"; // HTTPS geri döndü
// const API_BASE_URL = "https://localhost:7025/api"; // HTTPS geri döndü

// Image base URL (API prefix olmadan)
export const IMAGE_BASE_URL = API_BASE_URL.replace(/\/api$/, "");

// HTTPS sertifika doğrulamasını geçici olarak gevşet (sadece development)
process.env.NODE_TLS_REJECT_UNAUTHORIZED = "0";

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000, // 30 second timeout (QR kod oluşturma için artırıldı)
  headers: {
    "Content-Type": "application/json",
  },
});

// If a token exists in localStorage when the module loads, set the default
// Authorization header so requests from the first render include it.
try {
  const existingToken = localStorage.getItem("token");
  if (
    existingToken &&
    existingToken !== "undefined" &&
    existingToken !== "null" &&
    existingToken.length > 0
  ) {
    // Basit token format kontrolü (JWT should have 3 parts)
    const tokenParts = existingToken.split(".");
    if (tokenParts.length === 3) {
      api.defaults.headers.common["Authorization"] = `Bearer ${existingToken}`;
    } else {
      console.warn("API: Invalid token format in localStorage, clearing");
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    }
  }
} catch (e) {
  // localStorage might not be available in some environments; ignore failures
  // but keep request interceptor as a fallback.
  console.warn("Could not read token from localStorage during api init:", e);
}

// Request interceptor to add token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token && token !== "undefined" && token !== "null") {
      // Basit token format kontrolü
      const tokenParts = token.split(".");
      if (tokenParts.length === 3) {
        config.headers.Authorization = `Bearer ${token}`;
      } else {
        console.warn(
          "Request interceptor: Invalid token format, clearing localStorage",
        );
        localStorage.removeItem("token");
        localStorage.removeItem("user");
      }
    } else {
    }
    return config;
  },
  (error) => {
    console.error("Request interceptor error:", error);
    return Promise.reject(error);
  },
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error("API Error:", error);
    console.error("Error details:", {
      message: error.message,
      code: error.code,
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data,
      headers: error.response?.headers,
      request: error.request,
      config: error.config,
    });

    // Log the response data specifically for 400 errors
    if (error.response?.status === 400) {
      console.error("400 Bad Request Details:", {
        url: error.config?.url,
        method: error.config?.method,
        requestData: error.config?.data,
        requestDataParsed: (() => {
          try {
            return JSON.parse(error.config?.data || "{}");
          } catch {
            return error.config?.data;
          }
        })(),
        responseData: error.response?.data,
        validationErrors: error.response?.data?.errors,
        title: error.response?.data?.title,
        detail: error.response?.data?.detail,
        type: error.response?.data?.type,
        status: error.response?.data?.status,
        traceId: error.response?.data?.traceId,
      });

      // Additional parsing for common ASP.NET Core validation responses
      if (error.response?.data?.errors) {
        console.error(
          "Validation errors breakdown:",
          error.response.data.errors,
        );

        // Parse and display each validation error individually
        Object.keys(error.response.data.errors).forEach((field) => {
          const fieldErrors = error.response.data.errors[field];
          console.error(`❌ ${field} errors:`, fieldErrors);
          fieldErrors.forEach((errorMsg: string, index: number) => {
            console.error(`   ${index + 1}. ${errorMsg}`);
          });
        });
      }
    }

    if (error.response?.status === 401) {
      // Token'ı ve user'ı localStorage'dan temizle
      localStorage.removeItem("token");
      localStorage.removeItem("user");

      // Axios default headers'ı temizle
      delete api.defaults.headers.common["Authorization"];

      // Login sayfasına yönlendir
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  },
);

export default api;

// Helper function for making API requests
export const apiRequest = async (url: string, options: RequestInit = {}) => {
  const token = localStorage.getItem("token");

  const defaultHeaders: HeadersInit = {
    "Content-Type": "application/json",
  };

  if (token) {
    defaultHeaders.Authorization = `Bearer ${token}`;
  }

  const config = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
  };

  const fullUrl = url.startsWith("http") ? url : `${API_BASE_URL}${url}`;

  try {
    const response = await fetch(fullUrl, config);

    if (!response.ok) {
      if (response.status === 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        window.location.href = "/login";
        throw new Error("Unauthorized");
      }

      // Try to get error message from response body
      let errorMessage = `HTTP ${response.status}: ${response.statusText}`;
      try {
        const errorData = await response.json();
        console.error("Backend Error Response:", errorData); // Debug log

        if (errorData) {
          // Handle ASP.NET validation errors
          if (errorData.errors) {
            const validationErrors = Object.entries(errorData.errors)
              .map(
                ([field, messages]: [string, any]) =>
                  `${field}: ${
                    Array.isArray(messages) ? messages.join(", ") : messages
                  }`,
              )
              .join("\n");
            errorMessage = `Validation errors:\n${validationErrors}`;
          } else if (errorData.message || errorData.title || errorData.error) {
            errorMessage =
              errorData.message ||
              errorData.title ||
              errorData.error ||
              errorMessage;
          }
        }
      } catch (e) {
        // If response is not JSON, use text
        try {
          const errorText = await response.text();
          if (errorText) errorMessage = errorText;
        } catch (e2) {
          // Use default message
        }
      }

      throw new Error(errorMessage);
    }

    // Check if response has content
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      return response.json();
    }

    return response.text();
  } catch (error) {
    console.error("API Request failed:", error);
    throw error;
  }
};

// ============================================
// STOK BİRİM API İŞLEMLERİ
// ============================================

// Tüm stok birimlerini listele
export const getStockUnits = () => api.get("/StockUnit");

// Belirli bir stok birimini getir
export const getStockUnit = (id: string) => api.get(`/StockUnit/${id}`);

// Yeni stok birimi oluştur
export const createStockUnit = (data: {
  unitName: string;
  abbreviation?: string;
  sortOrder?: number;
}) => api.post("/StockUnit", data);

// Stok birimi güncelle
export const updateStockUnit = (
  id: string,
  data: {
    id: string;
    unitName: string;
    abbreviation?: string;
    sortOrder?: number;
    isActive?: boolean;
  },
) => api.put(`/StockUnit/${id}`, data);

// Stok birimi sil (soft delete)
export const deleteStockUnit = (id: string) => api.delete(`/StockUnit/${id}`);

// ============================================
// STOK KATEGORİ API İŞLEMLERİ
// ============================================

// Tüm stok kategorilerini listele
export const getStockCategories = () => api.get("/StockCategory");

// Belirli bir stok kategorisini getir
export const getStockCategory = (id: string) => api.get(`/StockCategory/${id}`);

// Yeni stok kategorisi oluştur
export const createStockCategory = (data: {
  name: string;
  description?: string;
}) => api.post("/StockCategory", data);

// Stok kategorisi güncelle
export const updateStockCategory = (
  id: string,
  data: { id: string; name: string; description?: string; isActive?: boolean },
) => api.put(`/StockCategory/${id}`, data);

// Stok kategorisi sil (soft delete)
export const deleteStockCategory = (id: string) =>
  api.delete(`/StockCategory/${id}`);

// ============================================
// STOK API İŞLEMLERİ
// ============================================

// Tüm stokları listele
export const getStocks = () => api.get("/Stock");

// Belirli bir stok kaydını getir
export const getStock = (id: string) => api.get(`/Stock/${id}`);

// Düşük stok uyarısı - minimum seviyenin altındaki ürünler
export const getLowStock = () => api.get("/Stock/LowStock");

// Kategoriye göre stokları listele
export const getStocksByCategory = (categoryId: string) =>
  api.get(`/Stock/ByCategory/${categoryId}`);

// Stok ara (isim, kod, açıklama, barkod)
export const searchStocks = (query: string) =>
  api.get(`/Stock/Search?query=${encodeURIComponent(query)}`);

// Tipe göre stok listele (Hammadde, YariMamul, Mamul)
export const getStocksByType = (type: string) =>
  api.get(`/Stock/ByType?type=${encodeURIComponent(type)}`);

// Tüm mamülleri listele
export const getMamulStocks = () => api.get("/Stock/Mamul");

// Tüm yarı mamülleri listele
export const getYariMamulStocks = () => api.get("/Stock/YariMamul");

// Tüm hammaddeleri listele
export const getHammaddeStocks = () => api.get("/Stock/Hammadde");

// Yeni stok oluştur
export const createStock = (data: {
  productCode: string;
  productName: string;
  description?: string;
  categoryId: string;
  stockType?: number;
  unit: string;
  currentStock: number;
  minimumStock?: number;
  maximumStock?: number;
  unitPrice?: number;
  currency?: string;
  warehouseLocation?: string;
  supplier?: string;
  color?: string;
  size?: string;
  barcode?: string;
}) => api.post("/Stock", data);

// Stok güncelle
export const updateStock = (
  id: string,
  data: {
    id: string;
    productCode: string;
    productName: string;
    description?: string;
    categoryId: string;
    stockType?: number;
    unit: string;
    currentStock: number;
    minimumStock?: number;
    maximumStock?: number;
    unitPrice?: number;
    currency?: string;
    warehouseLocation?: string;
    supplier?: string;
    color?: string;
    size?: string;
    barcode?: string;
    isActive?: boolean;
  },
) => api.put(`/Stock/${id}`, data);

// Stok sil (soft delete)
export const deleteStock = (id: string) => api.delete(`/Stock/${id}`);

// ============================================
// STOK HAREKETLERİ API İŞLEMLERİ
// ============================================

// Tüm stok hareketlerini listele
export const getStockMovements = () => api.get("/StockMovement");

// Belirli bir stok hareketini getir
export const getStockMovement = (id: string) => api.get(`/StockMovement/${id}`);

// Bir stoka ait tüm hareketleri getir
export const getStockMovementsByStock = (stockId: string) =>
  api.get(`/StockMovement/ByStock/${stockId}`);

// Bir siparişe ait stok hareketlerini getir
export const getStockMovementsByOrder = (orderId: number) =>
  api.get(`/StockMovement/ByOrder/${orderId}`);

// Hareket tipine göre listele (Giris, Cikis, Transfer, Sayim, Iade, Fire)
export const getStockMovementsByType = (type: string) =>
  api.get(`/StockMovement/ByType?type=${encodeURIComponent(type)}`);

// Tarih aralığına göre stok hareketlerini getir
export const getStockMovementsByDateRange = (
  startDate: string,
  endDate: string,
) =>
  api.get(
    `/StockMovement/ByDateRange?startDate=${startDate}&endDate=${endDate}`,
  );

// Yeni stok hareketi oluştur (giriş, çıkış, transfer, sayım, iade, fire)
export const createStockMovement = (data: {
  stockId: string;
  movementType: number;
  quantity: number;
  unitPrice?: number;
  totalPrice?: number;
  currency?: string;
  referenceNo?: string;
  referenceType?: string;
  description?: string;
  movementDate?: string;
  movedBy?: string;
  fromWarehouse?: string;
  toWarehouse?: string;
  relatedOrderId?: number;
}) => api.post("/StockMovement", data);

// Stok hareketi güncelle
export const updateStockMovement = (
  id: string,
  data: {
    id: string;
    stockId: string;
    movementType: number;
    quantity: number;
    unitPrice?: number;
    totalPrice?: number;
    currency?: string;
    referenceNo?: string;
    referenceType?: string;
    description?: string;
    movementDate?: string;
    movedBy?: string;
    fromWarehouse?: string;
    toWarehouse?: string;
    relatedOrderId?: number;
    isActive?: boolean;
  },
) => api.put(`/StockMovement/${id}`, data);

// Stok hareketi sil (soft delete - stok miktarı geri alınır)
export const deleteStockMovement = (id: string) =>
  api.delete(`/StockMovement/${id}`);

// ============================================
// STOK REÇETESİ (BOM) API İŞLEMLERİ
// ============================================

// Tüm reçeteleri listele
export const getStockRecipes = () => api.get("/StockRecipe");

// Belirli bir reçeteyi getir
export const getStockRecipe = (id: string) => api.get(`/StockRecipe/${id}`);

// Bir mamülün tüm malzemelerini getir
export const getStockRecipesByParent = (parentStockId: string) =>
  api.get(`/StockRecipe/ByParent/${parentStockId}`);

// Bir malzemenin kullanıldığı tüm mamülleri getir
export const getStockRecipesByChild = (childStockId: string) =>
  api.get(`/StockRecipe/ByChild/${childStockId}`);

// Tam malzeme ağacını getir (rekürsif BOM)
export const getFullBOM = (stockId: string) =>
  api.get(`/StockRecipe/FullBOM/${stockId}`);

// Yeni reçete oluştur
export const createStockRecipe = (data: {
  parentStockId: string;
  childStockId: string;
  requiredQuantity: number;
  wastagePercentage?: number;
  description?: string;
  sortOrder?: number;
}) => api.post("/StockRecipe", data);

// Reçete güncelle
export const updateStockRecipe = (
  id: string,
  data: {
    id: string;
    parentStockId: string;
    childStockId: string;
    requiredQuantity: number;
    wastagePercentage?: number;
    description?: string;
    sortOrder?: number;
    isActive?: boolean;
  },
) => api.put(`/StockRecipe/${id}`, data);

// Reçete sil
export const deleteStockRecipe = (id: string) =>
  api.delete(`/StockRecipe/${id}`);

// Üretim yap - mamül üret ve malzemeleri stoktan düş
export const consumeForProduction = (data: {
  stockId: string;
  quantity: number;
  referenceNo?: string;
  movedBy?: string;
  relatedOrderId?: string;
}) => api.post("/StockRecipe/ConsumeForProduction", data);

// ============================================
// ROL & YETKİ (RBAC) API İŞLEMLERİ
// ============================================
export const getRoles = () => api.get("/Role");
export const getRole = (id: number) => api.get(`/Role/${id}`);
export const createRole = (data: {
  name: string;
  description?: string;
  permissionIds?: number[];
}) => api.post("/Role", data);
export const updateRole = (
  id: number,
  data: { name?: string; description?: string; permissionIds?: number[] },
) => api.put(`/Role/${id}`, data);
export const deleteRole = (id: number) => api.delete(`/Role/${id}`);
export const setRolePermissions = (id: number, permissionIds: number[]) =>
  api.put(`/Role/${id}/permissions`, permissionIds);
export const assignRoleToUser = (userId: string, roleId: number) =>
  api.post("/Role/assign", { userId, roleId });
export const getPermissionCatalog = () => api.get("/Role/catalog");
export const syncPermissionCatalog = () => api.post("/Role/sync-catalog");
export const getMyPermissions = () => api.get("/Role/my-permissions");
